import React from 'react';
import Header from "../../components/header";
import Footer from "../../components/footer";
import { connect } from "react-redux";
import { getRecordsList, getApproxCost, validateFedexAvailability } from "../../services/patient/action";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import $ from 'jquery';
import DeleteModel from '../common/Model/deleteModel';
import { footer } from "../../components/footerSize";
import { NavLink } from "react-router-dom";
import { toast } from 'react-toastify';
import {  onlyNumbers} from "../common/keyValidation"
import moment from "moment";


class PatientRecord extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            recordList: [],
            thirdPartyRequestId:"",
            responseTimeList: [],
            authExpList: [],
            thirdPartyClassificationList: [],
            expirationId: "",
            responseTimeId: "",
            thirdPartyClassId: "",
            patientsTab:false,
            fedexValue: "",
            efaxValue: "",
            openPopUp: false,
            address: "",
            address2: "",
            city: "",
            state: "",
            zip: "",
            fname: "",
            lname: "",
            openConfirmPopUp: false,
            otherTextValid:false,
            errors: {
                fname: "",
                lname: "",
                address: "",
                address2: "",
                city: "",
                state: "",
                zip: "",
                faxNo: "",
                otherText:"",
                thirdPartyRequestId:""
            },

            formValid: false,
            fnameValid: false,
            lnameValid: false,
            addressValid: false,
            address2Valid: false,
            cityValid: false,
            stateValid: false,
            zipValid: false,
            startDate: null,
            endDate: null,
            faxNo: "",
            faxEditable: false,
            faxValid: false,
            uploadDocument: "",
            requestAll: false,
            todo: "",
            todos: [],
            stateList:[],
            oneValid:true,
            expirationIdValue : "",
            otherTextBox:false,
            otherText : "",
            expirationValue:"",
            thirdPartyClassValue:"",
            requestedDate:"",
            responseValue:"",
            twoValid :true,
            thirdValid:true,
            fourthValid:true,
            otherOneValid:true,
            otherTwoValid:true,
            thirdPartyRequestIdValid :false

        }
    }

    changeTodo = (event) => {
        this.setState({
            todo: event.target.value
        })
    }

    addTodo = () => {
        let { todo, todos } = this.state;

if(todo !== ""){

        let index = todos.length

        let obj = {
            "id": index + 1,
            "patientNames": todo
        }

        todos.push(obj)

        this.setState({
            todos,todo:""
        })
    }
    }

    removeTodo = (e, index) => {
        e.preventDefault()
        let { todos } = this.state;
        todos.splice(index, 1);
        this.setState({
            todos: todos
        })
    }
    validateField(fieldName, value) {
        const {
            errors,
            fnameValid,
            lnameValid,
            addressValid,
            address2Valid,
            cityValid,
            stateValid,
            zipValid,
            faxValid,
            otherTextValid,
            thirdPartyRequestIdValid

        } = this.state;

        let fieldValidationErrors = errors;
        let fnamevalid = fnameValid;
        let lnamevalid = lnameValid;
        let addressvalid = addressValid;
        let address2valid = address2Valid;
        let cityvalid = cityValid;
        let statevalid = stateValid;
        let zipvalid = zipValid;
        let faxvalid = faxValid;
        let otherTextvalid = otherTextValid;
        let thirdPartyRequestIdvalid = thirdPartyRequestIdValid;


        switch (fieldName) {
            case "address":
                addressvalid = !(value.length < 1);
                fieldValidationErrors.address = addressvalid
                    ? ""
                    : "Please enter the address";
                break;

            case "otherText":
                otherTextvalid = !(value.length < 1);
                fieldValidationErrors.otherText = otherTextvalid
                    ? ""
                    : "Please enter the address";
            break;

            case "address2":
                address2valid = !(value.length < 1);
                fieldValidationErrors.address2 = address2valid
                    ? ""
                    : "Please enter the address ";
                break;

            case "city":
                cityvalid = !(value.length < 1);
                fieldValidationErrors.city = cityvalid
                    ? ""
                    : "Please enter the city"
                break;

            case "state":
                statevalid = !(value.length < 1);
                fieldValidationErrors.state = statevalid
                    ? ""
                    : "Please enter the state"
                break;

            case "zip":
                zipvalid = !(value.length < 1);
                fieldValidationErrors.zip = zipvalid
                    ? ""
                    : "Please enter the zip"
                break;
            case "faxNo":
                faxvalid = value.match(/^\d{10}$/);
                fieldValidationErrors.faxNo = faxvalid
                    ? ""
                    : "Please enter valid fax number";
                break;
            case "fname":
                fnamevalid = !(value.length < 1);
                fieldValidationErrors.fname = fnamevalid
                    ? ""
                    : "Please enter the First name"
                break;
            case "lname":
                lnamevalid = !(value.length < 1);
                fieldValidationErrors.lname = lnamevalid
                    ? ""
                    : "Please enter the Last name"
                break;
                case "thirdPartyRequestId":
                   thirdPartyRequestIdvalid = !(value.length < 3);
                fieldValidationErrors.thirdPartyRequestId = thirdPartyRequestIdvalid
                    ? ""
                    : "Please enter the Third Party Request ID atleast 3 digits"
                break;
            default:
                break;
        }
        this.setState(
            {
                errors: fieldValidationErrors,
                fnameValid: fnamevalid,
                lnameValid: lnamevalid,
                addressValid: addressvalid,
                address2Valid: address2valid,
                cityValid: cityvalid,
                stateValid: statevalid,
                zipValid: zipvalid,
                faxValid: faxvalid,
                otherTextvalid : otherTextvalid,
                thirdPartyRequestIdvalid : thirdPartyRequestIdvalid
            },
            this.validateForm
        );

    }
    validateForm() {
        const {
            fnameValid,
            lnameValid,
            addressValid,
            address2Valid,
            cityValid,
            stateValid,
            zipValid,

        } = this.state;

        this.setState({
            formValid:
                fnameValid &&
                lnameValid &&
                addressValid &&
                address2Valid &&
                cityValid &&
                stateValid &&
                zipValid

        });
    }

    componentDidMount() {
        this.patientUpdate();
        function autoHeight() {
            $('.content').css('min-height', 0);
            $('.content').css('min-height', (
                $(document).height() + 32
                - $('.dashHeader').height()
                - $('.footer-section').height()
            ));
        }
        $(document).ready(function () {
            autoHeight();
        });
        $(window).resize(function () {
            autoHeight();
        });

        $(document).ready(function () {
            $(".inlineheadre a i").mouseover(function () {
                $(".inlineheadre a p").css("display", "block");
            });
            $(".inlineheadre a i").mouseleave(function () {
                $(".inlineheadre a p").css("display", "none");
            });
            $(".inlineheadre1 a").mouseover(function () {
                $(".inlineheadre1 a p").css("display", "block");
            });
            $(".inlineheadre1 a").mouseleave(function () {
                $(".inlineheadre1 a p").css("display", "none");
            });
        });

        // onDocumentReady function bind
        $(document).ready(function () {
            footer("#content");
        });

        // onResize bind of the function
        $(window).resize(function () {
            footer("#content");
        });

        if (this.props.getByLocationDetails) {
            let data = this.props.getByLocationDetails.stateListObj;
            this.setState({
              stateList: data
            })
          }
          if(this.props.profileDetails){
          if(this.props.profileDetails.commonUser.userType === "patient"){
              this.setState({
                otherOneValid : false,
                otherTwoValid:false,
              })
          }
          }

        let access_token = this.props.loginDetails;

        this.props.getRecordsList(access_token);
    }




    componentWillReceiveProps = nextProps => {

        if (nextProps.getRecordsListStatus) {
            let recordList = nextProps.getRecordsListDetails.recordTypeInfoList
            this.setState({
                recordList
            })
        }
        if (nextProps.getResponseTimeStatus) {
            let responseTimeList = nextProps.getResponseTimeListDetails.responseTimeList
            this.setState({
                responseTimeList
            })
        }
        if (nextProps.getAuthExpStatus) {
            let authExpList = nextProps.getAuthExpListDetails.expirationList
            this.setState({
                authExpList
            })
        }

        if (nextProps.getOtherClassificationsStatus) {
            let thirdPartyClassificationList = nextProps.getOtherClassificationsDetails.thirdPartyClassificationList
            this.setState({
                thirdPartyClassificationList
            })
        }

        if (nextProps.getApiCostStatus) {
            this.props.history.push("/FinalRequest")
        }

    }

    selectAll = () => {
        let recordList = this.state.recordList;
        let selectedAll = recordList.map((item) => {
            item.value = true
            return item
        })

        this.setState({
            recordList: selectedAll,
            otherTextBox :true,
            oneValid : false
        })
    }



    removeAll = () => {
        let recordList = this.state.recordList;
        let selectedAll = recordList.map((item) => {
            item.value = false
            return item
        })

        this.setState({
            recordList: selectedAll,
            otherTextBox :false,
            oneValid : true
        })
    }

    handleChange = (e) => {
        e.preventDefault();
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value }, () => {
            this.validateField(name, value);
        });
    };

    requestAll = () => {
        this.setState({
            requestAll: !this.state.requestAll,
            requestedDate:"Requested All Date",
            thirdValid:!this.state.thirdValid
        })
    }
    otherInput = () =>{
         debugger
        let recordList = this.state.recordList
        let otherTab =  recordList.filter(items =>{
           if(items.id === 13 ){
                   return items
           } 
       })
 
       if(otherTab[0].value){
           this.setState({
               otherTextBox : true
           })
       }else{
           this.setState({
               otherTextBox:false,
               otherText : ""
           })
       }
    }

    selectRecords = (e, record, key) => {
        let recordList = this.state.recordList;
        record.value = !record.value;
        recordList[key].value = record.value
        this.setState({
            recordList
        },()=>{
            let recordList = this.state.recordList
            this.otherInput();

            let valid =  recordList.filter(item =>{
            if(item.value === true){
                return item
            } 
        })

        let oneValid = valid.length >0 ? false : true
            this.setState({
                oneValid,
             })
        
        })
    }

    selectAuthExpTime = (e, time) => {
        this.setState({
            expirationId: e.target.value,
            expirationValue : time.validTill,
            twoValid : false
        })
    }

    selectThirdpartyType = (e,item) => {
        this.setState({
            thirdPartyClassId: e.target.value,
            thirdPartyClassValue: item.requestType,
            otherOneValid : false
        }, () => {
            if (this.state.thirdPartyClassId == 6) {
                this.setState({
                    patientsTab: true
                })
            }else{
                this.setState({
                    patientsTab: false
                }) 
            }
        })
    }

    handleStartDate = (date) => {
        this.setState({
            startDate: date,
            thirdValid:false
        },()=>{
            if(this.state.startDate == null || this.state.endDate == null){
                this.setState({
                    thirdValid:true

                })
            }
        });
    }

    handleEndDate = (date) => {
        this.setState({
            endDate: date,
            thirdValid:false
        },()=>{
            if(this.state.startDate == null || this.state.endDate == null){
                this.setState({
                    thirdValid:true

                })
            }
        });
    }



    selectResTime = (e,response) => {
        this.setState({
            responseTimeId: e.target.value,
            responseValue: response.responseTime,
            fourthValid : false
        })
    }

    selectFedex = () => {
        this.setState(
            { fedexChecked: !this.state.fedexChecked },
            () => {
                if (this.state.fedexChecked) {
                    this.setState({ fedexValue: "fedex" });
                } else {
                    this.setState({
                        fedexValue: ""
                    });
                }
            }
        );
    }

    selectEfax = () => {
        this.setState(
            { efaxChecked: !this.state.efaxChecked },
            () => {
                if (this.state.efaxChecked) {
                    this.setState({ efaxValue: "efax" });
                } else {
                    this.setState({
                        efaxValue: ""
                    });
                }
            }
        );
    }
    uploadDoc = (e) => {
        var filea = e.target.files[0];
         var file = e.target.value;
        var len = file.length;
        var ext = file.slice(len - 4, len);
        if(ext.toUpperCase() == ".PDF"){
        this.setState({
            uploadDocument: e.target.files[0],
            otherTwoValid:false
        })
         }
        else{
           toast.error("Only PDF files allowed.");
        }

        // if(!file.type.match('image/jp.*')) {
        //     alert("only JPG images");
          //  $("#form-id").get(0).reset(); //the tricky part is to "empty" the input file here I reset the form.
        //     return;
        // }



    }

    ApproximateCal = () => {
        let { efaxValue, fedexValue, recordList, expirationId, responseTimeId, address,
            address2,
            city,
            fname,
            lname,
            state,
            zip,
            startDate,
            endDate,
            faxNo,
            uploadDocument,
            todos,
            thirdPartyClassId,
             expirationValue,
            thirdPartyClassValue,
            requestedDate,
            responseValue,
            thirdPartyRequestId,
            otherText
        } = this.state;
        if(this.props.profileDetails.commonUser.userType === "patient"){
            thirdPartyClassId = "7"
        }

      
        let data = this.props.profileDetails.commonUser

          startDate = moment(this.state.startDate).format('YYYY-MM-DD HH:mm:ss')
          endDate = moment(this.state.endDate).format('YYYY-MM-DD HH:mm:ss')

        let userInfoId = data.userId;


        let requestToAddress = {
            address,
            address2,
            city,
            firstName:fname,
            lastName:lname,
            state,
            zip,
        }

      
        let recordsTypeDTO = recordList.filter((records) => {
            return records.value === true
        })
       
 
        recordsTypeDTO.map((record)=>{
            if(record.id == 13 && record.value === true ){
                debugger
                record.type = otherText
            }
            return record
        })
    
 
        let selFacilitydata = this.props.getSelectedFacilityDetails;

        let facilityInfoId = selFacilitydata.selectedFacilityId;
      //  let practionerInfoId = selFacilitydata.doctorId;

        let requestTypId = "";

        if (efaxValue && fedexValue) {
            requestTypId = efaxValue + "," + fedexValue
        } else if (efaxValue) {
            requestTypId = efaxValue
        } else if (fedexValue) {
            requestTypId = fedexValue
        }

        let token = this.props.loginDetails;
        let receiverState = requestToAddress.state;
        let receState = {
            receiverState,
        }

        let payload = {
            recordsTypeDTO,
            facilityInfoId,
            "recordStatusId": "1",
            userInfoId,
            responseTimeId,
            requestTypId,
            "requestStatusId": "1",
            expirationId,
            fromDate: startDate == "Invalid date" ? null : startDate,
            toDate: endDate == "Invalid date" ? null : endDate ,
            faxNo,
            requestToAddress,
            thirdPartyRequestId

        }
       let recordDetailsPayload = {
          expirationValue,
          thirdPartyClassValue,
          requestedDate,
          startDate,
          endDate,
          efaxValue,
          fedexValue,
          responseValue,
          otherText,
          todos,
          thirdPartyRequestId

       }

 
        let payloadForFinal = {
            recordsTypeDTO,
            facilityInfoId,
            "recordStatusId": "1",
            userInfoId,
            responseTimeId,
            requestTypId,
            "requestStatusId": "1",
            expirationId,
            fromDate: startDate == "Invalid date" ? null : startDate,
            toDate: endDate == "Invalid date" ? null : endDate ,
            faxNo,
            requestToAddress,
            uploadDocument,
            thirdPartyRequestId
        }

 

        let lastData =   {
            "thirdPartyPatients":todos
        }   



 
        var formData = new FormData();
        formData.append('requestDTO', JSON.stringify(payload));
        formData.append('multipartFile', uploadDocument);
        formData.append('thirdPartyClassId', thirdPartyClassId);
        formData.append('thirdPartyPatientNames', JSON.stringify(lastData));
        
        if ( requestTypId !=="" &&  requestTypId.includes("fedex") ) {
            this.props.validateFedexAvailability(token,receState, formData,   payloadForFinal, thirdPartyClassId, lastData,recordDetailsPayload)
        } else {
            this.props.getApproxCost(token, formData, payloadForFinal, thirdPartyClassId, lastData,recordDetailsPayload)
        }


    
    }



    patientUpdate = () => {
        let data = this.props.profileDetails.commonUser
        let address = data.address
        let address2 = data.address2
        let city = data.city
        let Name = (data.firstName + " " + data.lastName)
        let fname = data.firstName
        let lname = data.lastName
        let state = data.state
        let zip = data.zip
        let addressValid = address ? true : false
        let address2Valid = address2 ? true : false
        let cityValid = city ? true : false
        let stateValid = state ? true : false
        let zipValid = zip ? true : false
        let fnameValid = fname ? true : false
        let lnameValid = lname ? true : false
        this.setState({
            address,
            address2,
            city,
            Name,
            state,
            zip,
            fname,
            lname,
            fnameValid,
            lnameValid,
            addressValid,
            address2Valid,
            cityValid,
            stateValid,
            zipValid,
            formValid:
                fnameValid &&
                lnameValid &&
                addressValid &&
                address2Valid &&
                cityValid &&
                stateValid &&
                zipValid
        })

    }

    openPopUp = (e) => {
      //  document.body.classList.add('modal-open');

        this.setState({
            openPopUp: true
        })
    }

    openPop = () => {
      //  document.body.classList.add('modal-open');

        this.setState({
            openConfirmPopUp: true,

        })
    }
    closePop = () => {
      //  document.body.classList.remove('modal-open');

        this.setState({
            openConfirmPopUp: false
        })
    }

    closeFedexPop = () =>{
        this.setState({
            fedexChecked: false
        })
    }
    confirmOkay = () => {
     //   document.body.classList.remove('modal-open');

        this.setState({
            openConfirmPopUp: false,
            openPopUp: false,
        })

    }
  

    validationForAll = () =>{
        toast.dismiss();
        debugger
        if(this.state.oneValid){
            toast.dismiss();
            toast.error("Please Select Records Needed")
        } else if(this.state.otherTextBox && this.state.otherText === ""  ){
            console.log(this.state.otherTextBox , this.state.otherText, this.state.otherTextValid )
            toast.dismiss();
            toast.error("Please fill others text box")
        }else if(this.state.twoValid){
            toast.dismiss();
            toast.error("Please Select Authorization expiration time")
        } else if(this.state.otherOneValid){
            toast.dismiss();
            toast.error("Please Select Identifying the entity of requestor")
        } else if(this.state.thirdValid){
            toast.dismiss();
            toast.error("Please Select Record Period Time")
        }else if(this.state.fourthValid){
            toast.dismiss();
            toast.error("Please Select Preferred Response Time")
        }else if(this.state.otherTwoValid){
            toast.dismiss();
            toast.error("Please Upload Patient Consent Documentation (Only PDF files allowed)")
        }else if(this.state.thirdPartyRequestId.length < 3 && this.props.profileDetails.commonUser.userType === "other"){
            toast.dismiss();
            toast.error("Please enter the Third Party Request ID")
        }else {
            this.ApproximateCal();
        }
    }





    render() {
        const {
            address,
            address2,
            city,
            state,
            zip,
            fname,
            lname,
            errors,
            formValid,
            startDate,
            endDate,
            faxNo,
            requestAll,
            todo,
            todos,
            patientsTab,
            otherText,
            otherTextBox,
            thirdPartyRequestId
        } = this.state;

 
        // let faddress;
        // let faddress2;
        //  let fcity;
        //  let ffacilityName;
        //  let fstate;
        // let fzip;

        // if (this.props.getFacilityAddress) {
        //     let data = this.props.getFacilityAddress.facilityAddressDTO;

        //     faddress = data.address ? data.address : "";
        //     faddress2 = data.address2 ? data.address2 : "";
        //     fcity = data.city ? data.city : "";
        //     ffacilityName = data.facilityName ? data.facilityName : "";
        //     fstate = data.state ? data.state : "";
        //     fzip = data.zip ? data.zip : "";

        // }


     
        return (
            <>

                <Header status={"afterLogin"} routes={[{ "name": "Home", "route": "/PatientHome", }, { "name": "Select a Practice/Doctor", "route": "/PatientRequest", }, { "name": "Select Records", "route": "/PatientRecord", }]} />


                <div className="content">
                    <div className="contentSection" id="content">
                        <div className="container-fluid">
                        <form autocomplete="off">
                            <div className="bodyContent">
                                <h3 className="title-text">Step 2 : Select Records<sup>*</sup></h3>

                                {/* {/ <!-- Record Type --> /} */}
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                        <div className="sec-head"><h4>Records Needed</h4></div>

                                        <div className="request-btn pull-right">
                                            <button type="button" onClick={this.selectAll} className="req-btn">Request All</button>
                                            <button type="button" onClick={this.removeAll} className="clr-btn">Clear All</button>
                                        </div>
                                        <div className="clear"></div>
                                    </div>
                                </div>
                                <div className="check-sec">
                                    <div className="row">
                                        {this.state.recordList.length > 0 ?
                                            this.state.recordList.map((record, id) => {
                                                return (
                                                    <div key={id} className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mt-2">
                                                        <input className="inp-cbx" id={record.type} data-name={id}
                                                            onChange={(e) => this.selectRecords(e, record, id)} checked={record.value}
                                                            type="checkbox" style={{ display: "none" }} />
                                                        <label className="cbx" htmlFor={record.type}><span>
                                                            <svg width="12px" height="10px" viewBox="0 0 12 10"><polyline points="1.5 6 4.5 9 10.5 1"></polyline></svg>
                                                        </span><span className="check-lab">{record.type}</span></label>
                                                    </div>
                                                )
                                            }) : <tr style={{ background: "transparent" }}><td colspan="6"><img alt="" src="images/no-record-found.png" width="130px" style={{ opacity: "0.2" }} /></td></tr>
                                        }
                                        {otherTextBox && 
                                        <div  className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mt-2">
                                        <input type="text" name="otherText" value={otherText}
                                           onChange={this.handleChange} placeholder="Enter here" />
                                        </div>
                                        }

                                    </div>
                                </div>

                                {/* {/ <!-- Authorization --> /} */}
                                <div className="row mt-2">
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                        <div className="rtp">
                                            <div className="sec-head inlineheadre"><h4>Authorization Expiration<sup>*</sup></h4>
                                                <a href="javascript:void(0)">
                                                    <i className="fa fa-question" aria-hidden="true"></i>
                                                    <p>Please Enter Medical Record Expiration Time Frame.</p>
                                                </a>
                                            </div>
                                            <div className="clear"></div>
                                        </div>
                                    </div>
                                </div>
                                < div className="row mt-2 p-0to15">
                                    {this.state.authExpList.length > 0 ?
                                        this.state.authExpList.map((time, id) => {
                                            return (
                                                <div key={id} className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mt-2">
                                                    <input className="inp-cbx" onChange={(e) => this.selectAuthExpTime(e, time)} value={time.id} id={time.validTill} type="radio" name="reco" style={{ display: "none" }} />
                                                    <label className="cbx" htmlFor={time.validTill}><span>
                                                        <svg width="12px" height="10px" viewBox="0 0 12 10">
                                                            <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                                                        </svg></span><span className="check-lab">{time.validTill}</span></label>
                                                </div>
                                            )
                                        }) : "No records found"

                                    }

                                </div>
                                {this.props.profileDetails.commonUser.userType === "other" &&
                                    <>
                                        {/* {/ <!-- Other Classification types --> /} */}
                                        <div className="row mt-2">
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                        <div className="rtp">
                                                    <div className="sec-head inlineheadre1"><h4>Select Identifying the entity of requestor<sup>*</sup> </h4>

                                                    </div>
                                                    <div className="clear"></div>
                                                </div>
                                            </div>
                                        </div>
                                        < div className="row mt-2 p-0to15">

                                            {this.state.thirdPartyClassificationList.length > 0 ?
                                                this.state.thirdPartyClassificationList.map((item, id) => {
                                                    //06June2019 without kurra,added below condtion
                                                    if(+item.id != 7){
                                                    return (
                                                        <div key={id} className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mt-2">
                                                            <input className="inp-cbx" onChange={(e) => this.selectThirdpartyType(e, item)} value={item.id} id={item.requestType} type="radio" name="records" style={{ display: "none" }} />
                                                            <label className="cbx" htmlFor={item.requestType}><span>
                                                                <svg width="12px" height="10px" viewBox="0 0 12 10">
                                                                    <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                                                                </svg></span><span className="check-lab">{item.requestType}</span></label>
                                                        </div>
                                                    )}
                                                }) : "No records found"

                                            }

                                        </div>

                                        {/* {/ <!-- Add multiple patient names --> /} */}
                                      {patientsTab &&  
                                            <>
                                        <div className="row mt-2">
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">`
                                        <div className="rtp">
                                                    <div className="sec-head inlineheadre"><h4>Add Multiple Patients </h4>

                                                    </div>
                                                    <div className="clear"></div>
                                                </div>
                                            </div>
                                        </div>
                                        < div className="row mt-2 p-0to15">
                                            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12  ">
                                                <div className="sec-head">
                                                    <h4>Patient Name</h4>
                                                </div>
                                                <div>
                                                    <div className="row">
                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                            <input value={todo} onChange={this.changeTodo} />
                                                            <button type="button" onClick={this.addTodo} class="btnDefault mt-2">Add</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                           { todos.length > 0 &&
                                            <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12 auto-add-box">
                                            <ol> 
                                                {
                                                    todos.map((todo, index) => {
                                                        return <li key={index}   ><span>{todo.patientNames} </span><span><button><i class="fa fa-times" onClick={(e)=>this.removeTodo(e, index)} aria-hidden="true"></i></button></span></li>
                                                    })
                                                }
                                                 </ol>
                                            </div>
                                           }
                                        </div>
                                        <div className="row mt-2 p-0to15">
           
                                        </div>
                                        </>
                                      }
                                    </>
                                }

                                {/* {/ <!-- Record Peroid Time --> /} */}
                                <div className="row mt-2">
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                        <div className="rtp">
                                            <div className="sec-head"><h4>Record Period Time<sup>*</sup></h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mt-2">
                                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                        <div className="form-group">
                                            <DatePicker selected={startDate}  maxDate={new Date()} type="text" disabled={requestAll} dateFormat="MM-dd-yyyy" placeholderText="Start Date *" name="startDate"
                                                 onChange={this.handleStartDate} peekNextMont showMonthDropdown isClearable={true}
                                                showYearDropdown dropdownMode="select" autocomplete="false" />

                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                        <div className="form-group">
                                            <DatePicker selected={endDate} minDate={this.state.startDate}   maxDate={new Date()} type="text" disabled={requestAll} dateFormat="MM-dd-yyyy" placeholderText="End Date *" name="endDate"
                                              startDate={this.state.startDate}  onChange={this.handleEndDate} peekNextMont showMonthDropdown isClearable={true}
                                                showYearDropdown dropdownMode="select" autocomplete="false"/>

                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mt-2">
                                        <input className="inp-cbx" id="rcbot" disabled={startDate != null || endDate != null} type="checkbox" onChange={this.requestAll} style={{ display: "none" }} />
                                        <label className="cbx" htmlFor="rcbot"><span>
                                            <svg width="12px" height="10px" viewBox="0 0 12 10">
                                                <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                                            </svg></span><span className="check-lab">Request all dates</span></label>
                                    </div>

                                </div>
                             

                                {/* {/ <!-- Response Time --> /} */}
                                <div className="row mt-2">
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                        <div className="rtp">
                                            <div className="sec-head inlineheadre1"><h4>Preferred Response Time<sup>*</sup></h4>
                                            <a href="javascript:void(0)" className="preferred">
                                                    <i className="fa fa-question" aria-hidden="true"></i>
                                                    <p className="rp">Expedited delivery times are available Monday through Thursday only.</p>
                                                </a>
                                            </div>
                                            <div className="clear"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-2 p-0to15">
                                    {this.state.responseTimeList.length > 0 ?
                                        this.state.responseTimeList.map((response, id) => {
                                            return (
                                                <div key={id} className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mt-2">
                                                    <input className="inp-cbx" id={response.responseTime} onChange={(e) => this.selectResTime(e,response)} value={response.id} name="ResTime" type="radio" style={{ display: "none" }} />
                                                    <label className="cbx" htmlFor={response.responseTime}><span>
                                                        <svg width="12px" height="10px" viewBox="0 0 12 10">
                                                            <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                                                        </svg></span><span className="check-lab">{response.responseTime} ({" additional Cost -  $ " + response.additionalCost}) </span></label>
                                                </div>
                                            )
                                        }) : "No records found"

                                    }

                                </div>
                                {/* other Requestor document Upload  */}
                                {this.props.profileDetails.commonUser.userType === "other" &&
                                    <>
                                        <div className="row mt-2">
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                                <div className="rtp">
                                                    <div className="sec-head"><h4>Upload Patient Consent Documentation<sup>*</sup></h4></div>

                                                </div>

                                            </div>
                                        </div>
                                        <div>
                                            <div>
                                                <input type="file" id="form-id" accept=".pdf" onChange={this.uploadDoc} />

                                            </div>


                                        </div>
                                          <div className="row mt-2">
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                                        <div className="rtp">
                                            <div className="sec-head inlineheadre"><h4>Third Party Request Id<sup>*</sup></h4>
                                                <a href="javascript:void(0)">
                                                    <i className="fa fa-question" aria-hidden="true"></i>
                                                    <p>This is the record ID that will allow you and your company to identify this record independent of the epaperroad ID.</p>
                                                </a>
                                            </div>
                                            <div className="clear"></div>
                                        </div>
                                                 

                                            </div>
                                        </div>
                                               < div className="row mt-2 p-0to15">
                                            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12  ">
                                           
                                                     <div className="row">
                                                        <div className="custom-zero-padding col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                            <input value={thirdPartyRequestId} placeholder="Enter your third party request ID here" name="thirdPartyRequestId" onKeyPress={onlyNumbers} onChange={this.handleChange} />
                                                         </div>
                                                             <div style={{ color: "red" }}>{errors.thirdPartyRequestId}</div>
                                                    </div>
                                             </div>
                                       
                                        </div>
                                    </>
                                }

                                {/* {/ <!-- Delivery Method --> /} */}
                                <div className="row mt-2">
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                        <div className="rtp">
                                            <div className="sec-head"><h4>Preferred Delivery Method</h4></div>

                                        </div>

                                    </div>
                                </div>
                                <div className="row mt-2 p-0to15">
                                    {!(this.state.responseTimeId === "1" || this.state.responseTimeId === "2") &&
                                        <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mt-2">
                                            <input className="inp-cbx" id="rcbxs" type="checkbox" onChange={this.selectFedex} style={{ display: "none" }} />
                                            <label className="cbx" htmlFor="rcbxs">
                                            <span  >
                                                <svg  width="12px" height="10px" viewBox="0 0 12 10">
                                                    <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                                                </svg></span><span className="check-lab">Fedex ( Postage will be added )</span></label>
                                        </div>
                                    }
                                    <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mt-2">
                                        <input className="inp-cbx" id="rcbx11" type="checkbox" onChange={this.selectEfax} style={{ display: "none" }} />
                                        <label className="cbx" htmlFor="rcbx11"><span>
                                            <svg width="12px" height="10px" viewBox="0 0 12 10">
                                                <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                                            </svg></span><span className="check-lab">eFax ( Included )</span></label>
                                    </div>

                                    <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mt-2">
                                        <input className="inp-cbx" id="rcbf12" type="checkbox" checked={true} readOnly style={{ display: "none" }} />
                                        <label className="cbx" htmlFor="rcbf12"><span>
                                            <svg width="12px" height="10px" viewBox="0 0 12 10">
                                                <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                                            </svg></span><span className="check-lab">Download ( Included )</span></label>
                                    </div>

                                </div>


                                <div className="row mt-3">
                                   
                                       
           {/* <DeleteModel header="Sorry for the inconvenience" page="fedexService" text="Our Fedex service is unavailable. We expect this service to resume soon"   status={this.state.fedexChecked} confirmOkay={this.closeFedexPop}   />  */}
                                        {this.state.fedexChecked &&
                                            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 ">
                                                <div className="sec-head">
                                                    <h4>Records Going To</h4>
                                                </div>
                                                <div className="check-sec">
                                                    <div className="row">
                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                            <p>
                                                                {fname} {lname}<br />
                                                                {address},<br />
                                                                {address2},<br />
                                                                {city},{state} {zip}
                                                            </p>
                                                            <a href="javascript:void(0)"  onClick={this.openPopUp}>
                                                                <i className="fa fa-pencil" aria-hidden="true"></i>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                      
                                    {this.state.efaxChecked &&
                                        <>
                                            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 faxno ">
                                                <div className="sec-head">
                                                    <h4>Fax Number</h4>
                                                </div>
                                                <div>
                                                    <div className="row">
                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                            <input type="text" class="cotry-input" maxLength={10} value={faxNo} name="faxNo" onKeyPress={onlyNumbers} onChange={this.handleChange} />
                                                            <label class="country-code-fax">+1</label>
                                                        </div>

                                                    </div>
                                                </div>



                                            </div>
                                            <div style={{ color: "red" }}>{errors.faxNo}</div>

                                        </>
                                    }

                                </div>
                                {/* disabled={this.props.profileDetails.commonUser.userType == "other" ? this.state.uploadDocument == "" ? true : this.state.efaxChecked ? this.state.faxValid ? false : true : false : this.state.efaxChecked ? this.state.faxValid ? false : true : false} */}
                                <div className="row mt-3 mb-2 text-center">
                                    <NavLink to="/PatientRequest"> <button type="button" className="btnDefault">Back</button></NavLink>
                                    {/* <NavLink to="">  */}
                                    <button type="button" 
                                        onClick={this.validationForAll} className="btnDefault">Next</button>
                                    {/* </NavLink> */}
                                </div>

                            </div>
                       </form>
                        </div>
                    </div> </div>
                <Footer />

                {this.state.openPopUp &&
                    <div class="thanks-reg">
                        <div class="modal" id="myModal">
                            <div class="modal-dialog">
                                <div class="modal-content">

                                    {/* <!-- Modal Header --> */}
                                    <div class="modal-header">
                                        <h4>Change the Address</h4>
                                        <button type="button" class="close" onClick={() => { this.setState({ openPopUp: false }) }} >&times;</button>
                                    </div>

                                    {/* <!-- Modal body --> */}
                                    <div class="modal-body">
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <div class="address-pop">
                                                    <div class="row">
                                                        <div class="col-lg-6">
                                                            <div class="form-group">
                                                                <label>First Name</label><sup>*</sup>
                                                                <input type="text" name="fname" value={fname}
                                                                    onChange={this.handleChange} placeholder="First Name" />
                                                                <div style={{ color: "red" }}>{errors.fname}</div>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6">
                                                            <div class="form-group">
                                                                <label>Last Name</label><sup>*</sup>
                                                                <input type="text" name="lname" value={lname}
                                                                    onChange={this.handleChange} placeholder="Last Name" />
                                                                <div style={{ color: "red" }}>{errors.lname}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-6">
                                                            <div class="form-group">
                                                                <label>Address</label><sup>*</sup>
                                                                <input type="text" name="address" value={address}
                                                                    onChange={this.handleChange} placeholder="Address 1" />
                                                                <div style={{ color: "red" }}>{errors.address}</div>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6">
                                                            <div class="form-group">
                                                                <label>Address 2</label><sup>*</sup>
                                                                <input type="text" name="address2" value={address2}
                                                                    onChange={this.handleChange}   placeholder="Address 2" />
                                                                <div style={{ color: "red" }}>{errors.address2}</div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-lg-4">
                                                            <div class="form-group">
                                                                <label>City</label><sup>*</sup>
                                                                <input type="text" name="city" value={city}
                                                                    onChange={this.handleChange} placeholder="State" />
                                                                <div style={{ color: "red" }}>{errors.city}</div>
                                                            </div>
                                                        </div>
                                                        {/* <div class="col-lg-4">
                                                            <div class="form-group">
                                                                <label>State</label><sup>*</sup>
                                                                <input type="text" name="state" value={state}
                                                                    onChange={this.handleChange} placeholder="City" />
                                                                <div style={{ color: "red" }}>{errors.state}</div>
                                                            </div>
                                                        </div> */}
                                     <div class="col-lg-4">
                    <div class="form-group" >

                      <label for="state">State</label><sup>*</sup>
                      <select className="form-control" id="sel1" name="state" value={state} onChange={this.handleChange}>

                        <option value={""} >State </option>
                        {this.state.stateList.length > 0 ?
                          this.state.stateList.map((state, id) => {
                            return (
                              <option key={id}>{state.name} </option>

                            )
                          }) : ""

                        }

                      </select>
                    </div>
                    <span style={{ color: "red" }}>{errors.state}</span>

                  </div>
                                                        <div class="col-lg-4">
                                                            <div class="form-group">
                                                                <label>Zip</label><sup>*</sup>
                                                                <input type="text" name="zip" value={zip}
                                                                    onChange={this.handleChange} placeholder="Zip" />
                                                                <div style={{ color: "red" }}>{errors.zip}</div>
                                                            </div>
                                                        </div>
                                                    </div>



                                                    <div class="row">
                                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
                                                            <button type="button" disabled={!formValid} onClick={this.openPop} class="btnDefault">Update</button></div></div>
                                                    <DeleteModel header="Edit" text="Are you sure you want to edit?" page="editAddress" status={this.state.openConfirmPopUp} confirmOkay={this.confirmOkay} closePop={this.closePop} />


                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>

                }

            </>
        )
    }
}


const mapStateToProps = state => ({

    loginDetails: state.commonReducer.loginDetails,
    profileDetails: state.commonReducer.profileDetails,
    message: state.patientReducer.message,
    getRecordsListDetails: state.patientReducer.getRecordsListDetails,
    getRecordsListStatus: state.patientReducer.getRecordsListStatus,
    getResponseTimeStatus: state.patientReducer.getResponseTimeStatus,
    getResponseTimeListDetails: state.patientReducer.getResponseTimeListDetails,
    getAuthExpListDetails: state.patientReducer.getAuthExpListDetails,
    getAuthExpStatus: state.patientReducer.getAuthExpStatus,
    getSelectedFacilityDetails: state.patientReducer.getSelectedFacilityDetails,
    getFacilityAddress: state.patientReducer.getFacilityAddress,
    getApiCostStatus: state.patientReducer.getApiCostStatus,
    getOtherClassificationsDetails: state.patientReducer.getOtherClassificationsDetails,
    getOtherClassificationsStatus: state.patientReducer.getOtherClassificationsStatus,
    getByLocationDetails: state.patientReducer.getByLocationDetails,


});

const mapDispatchToProps = dispatch => ({
    getRecordsList: token => dispatch(getRecordsList(token)),
    getApproxCost: (token, formData, payloadForFinal, id, list,recordDetailsPayload) => dispatch(getApproxCost(token, formData, payloadForFinal, id, list,recordDetailsPayload)),

    validateFedexAvailability: (token,receState, formData, payloadForFinal, id, list ,recordDetailsPayload) => dispatch(validateFedexAvailability(token,receState, formData, payloadForFinal, id, list,recordDetailsPayload )),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PatientRecord); 